export default "__VITE_PUBLIC_ASSET__1e34fedd__"